





















import {Component, Prop} from 'vue-property-decorator'
import CardButton from './CardButton.vue'
import Avatar from './proxy/Avatar.vue'
import Img from '@/components/proxy/Image.vue'
import Button from '@/components/Button.vue'

@Component({
  components: {
    Button,
    Img,
    CardButton,
    Avatar,
  },
})
export default class CardDriver extends CardButton {
  @Prop({
    type: Boolean,
    default: true,
  }) public ripple!: boolean
  @Prop({}) public tile?: boolean
  @Prop({}) private image?: string
  @Prop({}) private id?: string
  @Prop({}) private name?: string
  @Prop({}) private status!: string
  @Prop({}) private hasPlan!: boolean
  @Prop({
    type: Boolean,
    default: false,
  }) private checkSubscription!: boolean

  private get statusFormatted() {
    let color
    if (this.status === 'ACTIVE') {
      color = '#21d37f'
    } else if (this.status === 'SUSPENDED') {
      color = '#ff5252'
    } else if (this.status === 'PENDING REVIEW') {
      color = '#ffc107'
    }
    return {
      status: this.$t(`profile.status.${this.status.replace(' ', '_').toLowerCase()}`),
      color,
    }
  }

  protected goToSubs() {
    this.$router.push({name: 'my subscriptions'})
  }
}
